import { render, staticRenderFns } from "./history.vue?vue&type=template&id=7a2c1b3f&scoped=true"
import script from "./history.vue?vue&type=script&setup=true&lang=js"
export * from "./history.vue?vue&type=script&setup=true&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=7a2c1b3f&prod&lang=css"
import style1 from "./history.vue?vue&type=style&index=1&id=7a2c1b3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c1b3f",
  null
  
)

export default component.exports